import { forwardRef as p, createElement as n } from "react";
/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var g = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f = (e, s) => {
  const o = p(
    ({
      color: i = "currentColor",
      size: r = 24,
      strokeWidth: a = 2,
      absoluteStrokeWidth: u,
      className: c = "",
      children: t,
      ...l
    }, d) => n(
      "svg",
      {
        ref: d,
        ...g,
        width: r,
        height: r,
        stroke: i,
        strokeWidth: u ? Number(a) * 24 / Number(r) : a,
        className: ["lucide", `lucide-${h(e)}`, c].join(" "),
        ...l
      },
      [
        ...s.map(([m, w]) => n(m, w)),
        ...Array.isArray(t) ? t : [t]
      ]
    )
  );
  return o.displayName = `${e}`, o;
};
export {
  f as c
};
